import { useMutation, useQueryClient } from 'react-query'
import { message } from 'antd'
import { postJSON } from 'common/services/api'
import { CreateProcedureInput, Procedure } from '../types'

interface UseProcedureCreateReturn {
  createProcedure: (
    input: CreateProcedureInput,
    residentId: string
  ) => Promise<Procedure>
  isCreating: boolean
}

export const useProcedureCreate = (
  onSuccess?: () => void
): UseProcedureCreateReturn => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async ({
      input,
      residentId
    }: {
      input: CreateProcedureInput
      residentId: string
    }) => {
      const response = await postJSON({
        url: '/api/list/procedures',
        json: {
          resident: residentId,
          title: input.title,
          description: input.description,
          procedureDateTime: input.procedureDateTime
        }
      })

      return response as Procedure
    },
    {
      onSuccess: (_, variables) => {
        message.success('Procedure created successfully')
        // Invalidate procedures list to refetch
        queryClient.invalidateQueries(['procedures', variables.residentId])
        if (onSuccess) {
          onSuccess()
        }
      },
      onError: (error: any) => {
        message.error(error?.message || 'Failed to create procedure')
      }
    }
  )

  const createProcedure = async (
    input: CreateProcedureInput,
    residentId: string
  ): Promise<Procedure> => {
    return mutation.mutateAsync({ input, residentId })
  }

  return {
    createProcedure,
    isCreating: mutation.isLoading
  }
}
